import React, { Fragment, useEffect, useRef, useState } from "react";
import {
  makeStyles,
  Grid,
  Typography,
  Paper,
  IconButton,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
} from "@material-ui/core";
import { Brush } from "@material-ui/icons";
import { useFetch } from "../../../features/customHooks/useFetch";
import Paint from "../../../components/paint/Paint";
import SketchView from "../../../components/util/sketch/SketchView";

const useStyles = makeStyles((theme) => ({}));

const Sketch = (props) => {
  const { data } = props;
  const { sketch = null, loading = true, canEdit = false, valuationId = 0, reget, valuation = [] } = data;
  const classes = useStyles();

  const [crookieDialogOpen, setCrookieDialogOpen] = useState(false);
  const paintRef = useRef(null);

  const [saveFetchState, setSaveFetchParams] = useFetch();

  const saveSketch = () => {
    var json = paintRef?.current?._sketch?.toJSON();
    var file = new Blob([JSON.stringify(json)], { type: "text/plain" });
    var formData = new FormData();

    formData.append("file", file);
    formData.append("valuation_id", valuationId);

    const headers = {
      "Content-Type": "multipart/form-data",
    };

    const params = {
      method: "post",
      url: "/upload_sketch",
      data: formData,
      headers: headers,
    };

    setSaveFetchParams(params);
  };

  useEffect(() => {
    if (!saveFetchState.loading && !saveFetchState.error && saveFetchState.data) {
      setCrookieDialogOpen(false);
      reget(saveFetchState?.data?.file_name);
    }

    if (!saveFetchState.loading && saveFetchState.error) {
      console.log(saveFetchState.error);
    }
  }, [saveFetchState]);

  return (
    <Paper style={{ padding: 10 }}>
      <Grid container alignItems='center'>
        <Typography variant='h6' style={{ fontWeight: "bold" }}>
          کروکی
        </Typography>
        <div style={{ flexGrow: 1 }} />
        {!loading && canEdit && (
          <Tooltip title='ویرایشگر کروکی' aria-label='ویرایشگر کروکی' placement='top'>
            <IconButton component='span' onClick={() => setCrookieDialogOpen(true)}>
              <Brush />
            </IconButton>
          </Tooltip>
        )}
      </Grid>

      {loading ? (
        <Grid container alignItems='center' justifyContent='center'>
          <CircularProgress style={{ color: "#757575" }} />
        </Grid>
      ) : (
        <Grid
          container
          direction='row'
          style={{
            padding: 10,
            borderRadius: 20,
            overflow: "hidden",
            backgroundColor: "#fff",
            pointerEvents: "none",
            marginTop: 10,
          }}
        >
          {valuation?.sketch_url ? (
            <SketchView data={{ sketch }} />
          ) : (
            <img
              src={process.env.REACT_APP_API_URL + "/crookie_images/" + valuation?.crookie_url}
              onError={(e) => {
                e.target.onerror = null;
                e.target.style.display = "none";
              }}
              style={{
                margin: 5,
                borderRadius: 15,
                border: "1px #757575 dashed",
                height: 340,
                width: 340,
              }}
              alt='crookie'
            />
          )}
        </Grid>
      )}
      {/* )} */}

      {!loading && canEdit && (
        <Dialog open={crookieDialogOpen} aria-labelledby='form-dialog-title' style={{ padding: 10 }}>
          <DialogTitle id='form-dialog-title'>ویرایشگر کروکی</DialogTitle>
          <DialogContent>
            <Paint ref={paintRef} sketch={sketch} />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setCrookieDialogOpen(false)} variant='text' color='primary'>
              لغو
            </Button>

            <Button onClick={saveSketch} color='secondary' variant='contained'>
              {saveFetchState?.loading ? <CircularProgress size={23} color='inherit' /> : "انجام"}
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </Paper>
  );
};

export default Sketch;
